module.exports = __webpack_public_path__ + "img/base-info.2d6d5c1d.png";